<template>
  <div class="page-home" v-loading="loading">
    <div class="banner">
      <h2>点亮你的创意 让创业更轻松</h2>
      <h3>
        {{ tutorCount }}位创业指导专家为你保驾护航、{{
          investorCount
        }}家投融资机构为你提供全链路成长服务
      </h3>
      <el-button type="primary" round :style="'margin-top:' + marginChange" @click="$router.push(`${$subsitePrefix}/innovation/create`)">马上申请</el-button>
      <!-- TODO投资人预留 -->
      <!-- <el-button type="primary" round @click="$router.push(`${$subsitePrefix}/innovation/investor-create`)">成为投资人</el-button> -->
    </div>
    <div class="g-wrap news-wrap">
      <div class="news">
        <column-header2 :data="newsColumn"></column-header2>
        <div class="column-wrap">
          <ic-slide-news :data="slideNews"></ic-slide-news>
          <ic-news :data="topNews"></ic-news>
        </div>
      </div>
      <div class="notice">
        <column-header2 :data="noticeColumn"></column-header2>
        <div class="column-wrap">
          <ic-news :data="noticeNews" type="calendar"></ic-news>
        </div>
      </div>
    </div>
    <div class="mentor-wrap">
      <div class="g-wrap">
        <column-header2 :data="{
            name: '双创导师',
            link: `${$subsitePrefix}/innovation/mentor-list`
          }"></column-header2>
        <div class="column-wrap">
          <template v-if="mentorList.length">
            <mentor-card v-for="item in mentorList" :data="item" :key="item.Id"></mentor-card>
          </template>
          <div v-else class="g-nodata"></div>
        </div>
      </div>
    </div>
    <div class="sc-wrap">
      <div class="g-wrap">
        <column-header2 :data="{
            name: '双创项目',
            link: `${$subsitePrefix}/innovation/sc-column`
          }"></column-header2>
        <div class="column-wrap">
          <template v-if="scList.length">
            <sc-card v-for="item in scList" :data="item" :key="item.Id"></sc-card>
          </template>
          <div class="g-nodata" v-else></div>
        </div>
      </div>
    </div>
    <div class="rz-wrap">
      <div class="g-wrap">
        <column-header2 :data="{
            name: '融资项目',
            link: `${$subsitePrefix}/innovation/rz-column`
          }"></column-header2>
        <div class="column-wrap">
          <template v-if="rzList.length">
            <rz-card v-for="item in rzList" :data="item" :key="item.Id"></rz-card>
          </template>
          <div class="g-nodata" v-else></div>
        </div>
      </div>
    </div>
    <div class="tzr-wrap">
      <div class="g-wrap">
        <column-header2 :data="{
            name: '投资人',
            link: `${$subsitePrefix}/innovation/investor-list`
          }"></column-header2>
        <div class="column-wrap">
          <template v-if="tzrList.length">
            <tzr-card v-for="item in tzrList" :data="item" :key="item.Id"></tzr-card>
          </template>
          <div class="g-nodata" v-else></div>
        </div>
      </div>
    </div>
    <div class="cy-wrap">
      <div class="g-wrap">
        <column-header2 :data="{
            name: '创业大赛',
            link: `${$subsitePrefix}/innovation/match-list`
          }"></column-header2>
        <div class="column-wrap">
          <template v-if="cyList.length">
            <cy-card v-for="item in cyList" :data="item" :key="item.Id"></cy-card>
          </template>
          <div class="g-nodata" v-else></div>
        </div>
      </div>
    </div>
    <div class="ly-wrap">
      <div class="g-wrap">
        <column-header2 :data="{
            name: '路演大厅',
            link: `${$subsitePrefix}/innovation/roadshow-list`
          }"></column-header2>
        <div class="column-wrap">
          <template v-if="lyList.length">
            <ly-card v-for="item in lyList" :data="item" :key="item.Id"></ly-card>
          </template>
          <div class="g-nodata" v-else></div>
        </div>
      </div>
    </div>
    <div class="lm-wrap">
      <div class="g-wrap">
        <column-header2 :data="{
            name: '创业联盟',
            link: `${$subsitePrefix}/innovation/league-list`
          }"></column-header2>
        <div class="column-wrap">
          <template v-if="lmList.length">
            <lm-card v-for="item in lmList" :data="item" :key="item.Id"></lm-card>
          </template>
          <div class="g-nodata" v-else></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import {
  getInnovationPageList,
  getTutorCount,
  getInvestorCount
} from "api/innovation";

import ColumnHeader from "_c/ColumnHeader2";
import SlideNews from "_c/SlideNews";
import News from "_c/News";
import MentorCard from "./components/MentorCard";
import SCCard from "./components/SCCard";
import RZCard from "./components/RZCard";
import TZRCard from "./components/TZRCard";
import CYCard from "./components/CYCard";
import LYCard from "./components/LYCard";
import LMCard from "./components/LMCard";
import { mapState } from "vuex";
// import rzList from "./mock/rzList.json";
// import tzrList from "./mock/tzrList.json";
// import cyList from "./mock/cyList.json";
// import lyList from "./mock/lyList.json";
// import lmList from "./mock/lmList.json";

export default {
  data() {
    return {
      marginChange: "8px",
      tutorCount: null,
      investorCount: null,
      newsColumn: {
        name: "双创资讯",
        link: "innovation/list/TopNews"
      },
      noticeColumn: {
        name: "双创政策",
        link: "innovation/list/InnovationPolicy"
      },

      loading: false,
      slideNews: [],
      topNews: [],
      noticeNews: [],
      mentorList: [],
      scList: [],
      rzList: [],
      tzrList: [],
      cyList: [],
      lyList: [],
      lmList: [],
      cid: "",
      params: []
    };
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [SlideNews.name]: SlideNews,
    [News.name]: News,
    [MentorCard.name]: MentorCard,
    [SCCard.name]: SCCard,
    [RZCard.name]: RZCard,
    [TZRCard.name]: TZRCard,
    [CYCard.name]: CYCard,
    [LYCard.name]: LYCard,
    [LMCard.name]: LMCard
  },
  methods: {
    //双创资讯轮播
    loadSlideNews() {
      const linkDecorator = item => {
        item.link =
          this.$subsitePrefix + `/innovation/detail/${item.name}?id=${item.id}`;
        return item;
      };
      let queryParams = Object.assign([], this.params);
      queryParams.push({
        Key: "Illustration",
        Value: "",
        CompareType: "NotEqualTo"
      });
      getData({ name: "TopNews", top: 5, params: queryParams }).then(res => {
        const arr = [];
        res.forEach(el => {
          arr.push({
            Headline: el.Headline,
            IssueTime: el.PublishTime,
            Summary: el.Summary,
            Illustration: el.Illustration,
            id: el.Id,
            name: "TopNews"
          });
        });
        this.slideNews = (arr || []).map(linkDecorator);
        // debugger
      });
    },
    //双创资讯新闻列表
    loadTopNews() {
      const linkDecorator = item => {
        item.link =
          this.$subsitePrefix + `/innovation/detail/${item.name}?id=${item.id}`;
        return item;
      };
      getData({ name: "TopNews", top: 4, params: this.params })
        .then(res => {
          const arr = [];
          res.forEach(el => {
            arr.push({
              Headline: el.Headline,
              IssueTime: el.PublishTime,
              Summary: el.Summary,
              Illustration: el.Illustration,
              id: el.Id,
              name: "TopNews"
            });
          });
          this.topNews = (arr || []).map(linkDecorator);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //双创政策
    loadNoticeNews() {
      const linkDecorator = item => {
        item.link =
          this.$subsitePrefix + `/innovation/detail/${item.name}?id=${item.id}`;
        return item;
      };
      getData({ name: "InnovationPolicy", top: 4, params: this.params })
        .then(res => {
          const arr = [];
          res.forEach(el => {
            arr.push({
              Headline: el.Headline,
              IssueTime: el.PublishTime,
              Summary: el.Summary,
              Illustration: el.Illustration,
              id: el.Id,
              name: "InnovationPolicy"
            });
          });
          this.noticeNews = (arr || []).map(linkDecorator);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCount() {
      getTutorCount({ College: this.collegeData.cid })
        .then(res => {
          this.tutorCount = res.Result;
        })
        .catch(err => {
          console.log(err);
        });
      getInvestorCount()
        .then(res => {
          this.investorCount = res.Result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    init() {
      this.getCount();
      this.loadSlideNews();
      this.loadTopNews();
      this.loadNoticeNews();
      //双创导师
      // let queryParams = Object.assign([], this.params);
      // queryParams.push({
      //   Key: "Type",
      //   Value: 3,
      //   CompareType: "EqualTo"
      // });
      // getData({ name: "Tutor", top: 3, params: queryParams })
      //   .then(res => {
      //     this.mentorList = res || [];
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      var queryParams = {
        College: this.collegeData.cid,
        PageIndex: this.pageIndex,
        PageSize: this.pageSize ?? 3
      };
      getInnovationPageList(queryParams)
        .then(res => {
          this.mentorList = res.Result.Data || [];
        })
        .catch(err => {
          console.log(err);
        });
      //双创项目
      let innovationProjectQueryParams = Object.assign([], this.params);
      innovationProjectQueryParams.push({
        Key: "WorkFlowState",
        Value: 2,
        CompareType: "GreaterThan"
      });
      getData({
        name: "InnovationProject",
        top: 3,
        params: innovationProjectQueryParams
      })
        .then(res => {
          this.scList = res || [];
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
      //融资项目
      let financingQueryParams = Object.assign([], this.params);
      financingQueryParams.push({
        Key: "WorkFlowState",
        Value: 2,
        CompareType: "GreaterThan"
      });
      getData({
        name: "InnovationProject",
        top: 6,
        params: financingQueryParams
      })
        .then(res => {
          this.rzList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
      //投资人
      let investorParams = []
      investorParams.push({
        Key: "WorkFlowState",
        Value: 2,
        CompareType: "GreaterThan"
      });
      getData({ name: "Investor", top: 4, params: investorParams })
        .then(res => {
          this.tzrList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
      // 创业大赛
      let matchParams = Object.assign([], this.params);
      matchParams.push({
        Key: "WorkFlowState",
        Value: 2,
        CompareType: "GreaterThan"
      });
      getData({ name: "match", top: 3, params: matchParams })
        .then(res => {
          this.cyList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
      // 路演大厅
      let roadShowQueryParams = Object.assign([], this.params);
      roadShowQueryParams.push({
        Key: "WorkFlowState",
        Value: 2,
        CompareType: "GreaterThan"
      });
      getData({ name: "Roadshow", top: 3, params: roadShowQueryParams })
        .then(res => {
          this.lyList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
      // 创业联盟
      getData({ name: "League", top: 4, params: this.params })
        .then(res => {
          this.lmList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.cid = this.collegeData.cid;
    this.params = [{ Key: "College", Value: this.cid, CompareType: "EqualTo" }];
    this.loading = true;
    this.init();
  },
  mounted() {
    setTimeout(_ => {
      this.marginChange = "70px";
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
.page-home {
  .banner {
    color: #fff;
    text-align: center;
    background: url(~assets/img/feature/innovation/banner.png) no-repeat center
      top;
    background-size: 100% auto;
    height: 368px;
    h2 {
      font-size: 36px;
      line-height: 50px;
      font-weight: 500;
      letter-spacing: 0.1em;
      padding-top: 100px;
    }
    h3 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      padding-top: 10px;
    }
    .el-button {
      background: $primary-color;
      border: 1px solid $primary-color;
      transition: all 1.5s;
      width: 240px;
    }
  }
  .column-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .news-wrap {
    display: flex;
    @include clearfix();
    padding-bottom: 40px;
    .news {
      margin-right: 24px;
    }
    .comp-slide-news {
      width: 376px;
      margin-right: 24px;
      height: 266px;
    }
    .comp-news {
      width: 376px;
      height: 266px;
    }
  }
  .mentor-wrap,
  .lm-wrap,
  .rz-wrap,
  .cy-wrap {
    background-color: #f6f6f9;
    padding-bottom: 16px;
  }
  .sc-wrap,
  .tzr-wrap,
  .ly-wrap {
    padding-bottom: 16px;
  }
}
</style>
